const VerticalSpacer = ({ ...props }) => {
  const { h } = props;
  return <span style={{ height: h ? h + "em" : "2em" }} />;
};
export default VerticalSpacer;
